import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router";
import logo from "../assets/logo.png";
import icon from "../assets/logo.ico";
import screenshot1 from "../assets/1.png";

export function meta() {
  return [
    {
      title:
        "سياسة الخصوصية - أديم المناسبات | حماية البيانات الشخصية",
    },
    {
      name: "description",
      content:
        "تعرف على سياسة الخصوصية لتطبيق أديم المناسبات وكيفية حماية البيانات الشخصية وفقاً لنظام حماية البيانات الشخصية في المملكة العربية السعودية.",
    },
    {
      name: "keywords",
      content:
        "سياسة الخصوصية، حماية البيانات، الخصوصية، أديم المناسبات، بيانات شخصية، أمان البيانات، حقوق المستخدم، المملكة العربية السعودية",
    },
    {
      name: "author",
      content: "أديم المناسبات",
    },
    {
      name: "robots",
      content: "index, follow",
    },
    {
      name: "language",
      content: "Arabic",
    },
    {
      name: "geo.region",
      content: "SA",
    },
    {
      name: "geo.country",
      content: "Saudi Arabia",
    },
    {
      name: "geo.placename",
      content: "المملكة العربية السعودية",
    },
    {
      name: "apple-mobile-web-app-capable",
      content: "yes",
    },
    {
      name: "apple-mobile-web-app-status-bar-style",
      content: "black-translucent",
    },
    {
      name: "apple-mobile-web-app-title",
      content: "أديم المناسبات - سياسة الخصوصية",
    },
    {
      name: "mobile-web-app-capable",
      content: "yes",
    },
    {
      name: "theme-color",
      content: "#58654C",
    },
    {
      name: "msapplication-TileColor",
      content: "#58654C",
    },
    // Open Graph Meta Tags
    {
      property: "og:title",
      content:
        "سياسة الخصوصية - أديم المناسبات | حماية البيانات الشخصية",
    },
    {
      property: "og:description",
      content:
        "تعرف على سياسة الخصوصية لتطبيق أديم المناسبات وكيفية التعامل مع البيانات الشخصية وحمايتها في المملكة العربية السعودية.",
    },
    {
      property: "og:image",
      content: logo,
    },
    {
      property: "og:image:width",
      content: "1200",
    },
    {
      property: "og:image:height",
      content: "630",
    },
    {
      property: "og:image:alt",
      content: "أديم المناسبات - سياسة الخصوصية",
    },
    {
      property: "og:url",
      content: "https://adim-app.com/privacy",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:site_name",
      content: "أديم المناسبات",
    },
    {
      property: "og:locale",
      content: "ar_SA",
    },
    // Twitter Card Meta Tags
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: "سياسة الخصوصية - أديم المناسبات",
    },
    {
      name: "twitter:description",
      content:
        "تعرف على سياسة الخصوصية لتطبيق أديم المناسبات وكيفية حماية البيانات الشخصية في المملكة العربية السعودية.",
    },
    {
      name: "twitter:image",
      content: logo,
    },
    {
      name: "twitter:image:alt",
      content: "أديم المناسبات - سياسة الخصوصية",
    },
    // App Store Meta Tags
    {
      name: "apple-itunes-app",
      content: "app-id=app-id=6758246638",
    },
    {
      name: "google-play-app",
      content: "app-id=com.adim.events",
    },
    // Canonical URL
    {
      tagName: "link",
      rel: "canonical",
      href: "https://adim-app.com/privacy",
    },
    // Favicon
    {
      tagName: "link",
      rel: "icon",
      type: "image/x-icon",
      href: icon,
    },
    {
      tagName: "link",
      rel: "apple-touch-icon",
      href: logo,
    },
    // Structured Data JSON-LD
    {
      tagName: "script",
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "سياسة الخصوصية - أديم المناسبات",
        description:
          "سياسة الخصوصية لتطبيق أديم المناسبات في المملكة العربية السعودية",
        url: "https://adim-app.com/privacy",
        isPartOf: {
          "@type": "WebSite",
          name: "أديم المناسبات",
          url: "https://adim-app.com",
        },
        inLanguage: "ar-SA",
        publisher: {
          "@type": "Organization",
          name: "أديم المناسبات",
          url: "https://adim-app.com",
          logo: logo,
        },
      }),
    },
  ];
}

export default function Privacy() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("data-collection");

  // Add/remove body class when menu opens/closes
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isMenuOpen]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#58654C]">
      
      {/* Header / Nav */}
      <header className="fixed top-0 left-0 right-0 z-40 bg-[#58654C] backdrop-blur-md border-b-2 border-[#BFA15D] shadow-xl md:mx-[6em] mx-[1em] mt-[.5em] rounded-[5em]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <nav
            className="flex items-center justify-between h-16 lg:h-20"
            role="navigation"
            aria-label="القائمة الرئيسية"
          >
            {/* Logo */}
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <img
                src={logo}
                alt="شعار أديم المناسبات"
                className="h-10 lg:h-12 brightness-0 invert"
                height="48"
              />
            </div>

            {/* Desktop Navigation */}
            <ul
              className="hidden md:flex items-center rtl:space-x-reverse gap-[2em]"
              role="menubar"
            >
              <li role="menuitem">
                <Link
                  to="/"
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى الصفحة الرئيسية"
                >
                  الرئيسية
                </Link>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }}
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم خدماتنا"
                >
                  خدماتنا
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }}
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم لماذا أديم"
                >
                  لماذا أديم
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document.getElementById("screenshots")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }}
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم شاشات التطبيق"
                >
                  شاشات التطبيق
                </button>
              </li>
               <li role="menuitem">
                <Link
                  to="/terms"
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم شروط وأحكام الاستخدام"
                >
                  شروط وأحكام الاستخدام  
                </Link>
              </li>
              <li role="menuitem">
                <span
                  className="text-[#BFA15D] transition-colors duration-200 text-sm font-medium cursor-default"
                  aria-label="سياسة الخصوصية (الصفحة الحالية)"
                >
                  سياسة الخصوصية
                </span>
              </li>
            </ul>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-all duration-300 hover:scale-110 transform"
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
              aria-label={isMenuOpen ? "إغلاق القائمة" : "فتح القائمة"}
            >
              <svg
                className={`w-6 h-6 transition-transform duration-300 ${isMenuOpen ? "rotate-90 scale-90" : "rotate-0 scale-100"}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </nav>
        </div>
      </header>
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div
          className="mobile-menu-overlay md:hidden fixed inset-0 bg-[#58654C] transition-all duration-500 ease-in-out opacity-100 visible animate-fadeIn"
          style={{
            zIndex: "999999 !important",
            backgroundColor: "#58654C",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            margin: 0,
            padding: 0,
            animation: "fadeInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {/* Menu Content */}
          <div className="relative h-full flex flex-col animate-slideInUp">
            {/* Header with Close Button */}
            <div
              className="flex items-center justify-between p-6 border-b border-white/20 animate-slideInDown"
              style={{ animationDelay: "0.1s" }}
            >
              <div className="flex items-center gap-3">
                <img
                  src={logo}
                  alt="أديم"
                  className="h-8 brightness-0 invert animate-bounceIn"
                  style={{ animationDelay: "0.3s" }}
                />
              </div>

              <button
                onClick={() => setIsMenuOpen(false)}
                className="p-2 rounded-lg text-white hover:bg-white/10 transition-all duration-300 hover:scale-110 hover:rotate-90 animate-fadeInRight"
                style={{ animationDelay: "0.2s" }}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Navigation Links */}
            <div
              className="flex-1 flex flex-col justify-start items-start px-1 text-right animate-fadeInUp mt-8"
              style={{ animationDelay: "0.4s" }}
            >
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.5s" }}
              >
                الرئيسية
              </Link>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.5s" }}
              >
                خدماتنا
              </button>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.6s" }}
              >
                لماذا أديم
              </button>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("screenshots")?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.7s" }}
              >
                شاشات التطبيق
              </button>
               <Link
                to="/terms"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.7s" }}
              >
                شروط وأحكام الاستخدام
              </Link>
               <span
                className="block w-full py-4 text-[#BFA15D] text-md font-medium px-4 text-right transition-all duration-300 animate-slideInLeft"
                style={{ animationDelay: "0.8s" }}
              >
                سياسة الخصوصية
              </span>
            </div>

            {/* Screenshot Display - Bottom Half */}
            <div
              className="relative h-100 overflow-hidden animate-fadeInUp rounded flex justify-center"
              style={{ animationDelay: "0.9s" }}
            >
              <img
                src={screenshot1}
                alt="شاشة التطبيق"
                className="absolute bottom-[-7em] w-auto h-full object-top rounded"
              />
            </div>
          </div>
        </div>
      )}
      {/* Main Content */}
      <main id="main" role="main">
        {/* Hero Section */}
        <section className="pt-32 pb-16 lg:pb-24 bg-gradient-to-br to-white via-gray-50 from-[#58654C]/10">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col lg:flex-row justify-center items-center gap-12 lg:gap-16">
                <div className="relative bg-gradient-to-r from-[#58654C]/5 to-[#BFA15D]/5 rounded-3xl p-8 lg:p-12">
                  <h1 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-[#58654C] mb-6 leading-10 text-center px-5">
                    سياسة الخصوصية لتطبيق أديم المناسبات
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Privacy Notice */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <div className="bg-gradient-to-r to-[#BFA15D]/10 via-transparent from-[#BFA15D]/10 border-r-4  p-6 mb-8 rounded-lg text-center">
                <p className="text-lg text-gray-700 leading-relaxed">
                  <strong>تحرص منصة أديم المناسبات على حماية خصوصية مستخدميها</strong>
                  <br />
                  <p className="p-0 m-0 text-sm mt-2">
                    وتلتزم بمعالجة البيانات الشخصية وفقاً لنظام حماية البيانات الشخصية المعمول به في المملكة العربية السعودية
                  </p>
                </p>
              </div>

              <div className="text-center mb-12">
                <h2 className="text-2xl lg:text-3xl font-bold text-[#58654C] mb-4">
                  فهرس المحتويات
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-md">
                  انقر على أي قسم للانتقال إليه مباشرة
                </p>
              </div>

              {/* Tabs Navigation */}
              <div className="grid grid-cols-2 sm:flex flex-wrap justify-center gap-2 mb-8 p-2 bg-gray-100 rounded-xl">
                <button
                  onClick={() => setActiveTab("data-collection")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "data-collection"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الأول</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    جمع البيانات
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab("usage-purpose")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "usage-purpose"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الثاني</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    استخدام البيانات
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab("data-sharing")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "data-sharing"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الثالث</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    مشاركة البيانات
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab("rights-protection")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "rights-protection"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الرابع</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    الحماية والحقوق
                  </div>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Privacy Content */}
        <div className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto">
              {/* Section 1: Data Collection */}
              {activeTab === "data-collection" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الأول: البيانات التي نقوم بجمعها
                  </h2>

                  <div className="space-y-8">
                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        بيانات الحساب
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• الاسم</p>
                        <p>• رقم الجوال</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        بيانات الطلبات
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• موقع المناسبة</p>
                        <p>• تاريخ ووقت المناسبة</p>
                        <p>• تفاصيل الطلب</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        بيانات الدفع
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• تتم معالجة بيانات الدفع عبر مزودي خدمات الدفع المعتمدين</p>
                        <p><strong>• لا نقوم بتخزين بيانات البطاقات البنكية بشكل مباشر</strong></p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        بيانات مزودي الخدمات
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• السجل التجاري أو وثيقة العمل الحر</p>
                        <p>• بيانات التواصل</p>
                        <p>• بيانات الحساب البنكي</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        بيانات تقنية
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• نوع الجهاز</p>
                        <p>• نظام التشغيل</p>
                        <p>• عنوان IP</p>
                        <p>• سجلات الاستخدام داخل التطبيق</p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Section 2: Usage Purpose */}
              {activeTab === "usage-purpose" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الثاني: الغرض من جمع البيانات
                  </h2>
                  <div className="space-y-8">
                    <div className="bg-gray-50 border rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        أغراض الاستخدام
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          <strong className="text-[#58654C] text-sm">
                            نستخدم البيانات من أجل:
                          </strong>
                        </p>
                        <p>• إنشاء وإدارة الحسابات</p>
                        <p>• تنفيذ الطلبات بين العميل ومزود الخدمة</p>
                        <p>• معالجة المدفوعات</p>
                        <p>• التواصل مع المستخدمين</p>
                        <p>• تحسين تجربة الاستخدام</p>
                        <p>• الامتثال للأنظمة والجهات الرسمية عند الطلب</p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Section 3: Data Sharing */}
              {activeTab === "data-sharing" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الثالث: مشاركة البيانات
                  </h2>
                  <div className="space-y-8">
                    <div className="bg-gray-50 border rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        الجهات التي قد نشارك معها البيانات
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• مزودي خدمات الدفع الإلكتروني</p>
                        <p>• شركات الاستضافة والخدمات التقنية</p>
                        <p>• مزودي خدمات الخرائط والموقع</p>
                        <p>• الجهات الحكومية عند وجود التزام نظامي</p>
                        <p className="mt-4">
                          <strong>ولا تتم مشاركة أي بيانات إلا بالقدر اللازم لتشغيل الخدمة.</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Section 4: Rights and Protection */}
              {activeTab === "rights-protection" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الرابع: الحماية والحقوق
                  </h2>
                  <div className="space-y-8">
                    <div className="bg-gray-50 border rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        حماية البيانات
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          <strong>نلتزم باتخاذ الإجراءات الفنية والتنظيمية المناسبة لحماية البيانات، ومنها:</strong>
                        </p>
                        <p>• تشفير البيانات الحساسة</p>
                        <p>• تقييد الوصول للبيانات</p>
                        <p>• أنظمة حماية تقنية متقدمة</p>
                        <p>• تدريب العاملين على سرية المعلومات</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        مدة الاحتفاظ بالبيانات
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>نحتفظ بالبيانات طالما كانت:</p>
                        <p>• لازمة لتقديم الخدمة</p>
                        <p>• مطلوبة نظاميًا</p>
                        <p>• أو لتحقيق أغراض مشروعة</p>
                        <p>ويتم حذف أو إخفاء هوية البيانات بعد انتهاء الغرض منها متى أمكن ذلك نظاميًا.</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        حقوق المستخدم
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p><strong>يحق للمستخدم وفق النظام:</strong></p>
                        <p>• طلب الاطلاع على بياناته</p>
                        <p>• طلب تصحيح البيانات</p>
                        <p>• طلب حذف البيانات غير اللازمة</p>
                        <p>• سحب الموافقة على المعالجة في بعض الحالات</p>
                        <p><strong>وذلك عبر التواصل مع دعم التطبيق.</strong></p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        ملفات تعريف الارتباط والتتبع
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>قد نستخدم تقنيات تحليلية وملفات تعريف ارتباط لأغراض:</p>
                        <p>• تحسين الأداء</p>
                        <p>• تحليل الاستخدام</p>
                        <p>• تطوير الميزات</p>
                        <p>ولا تستخدم هذه البيانات لتحديد هوية المستخدم بشكل مباشر.</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        الروابط الخارجية
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>قد يحتوي التطبيق على روابط أو خدمات تابعة لأطراف خارجية، ولا تتحمل المنصة مسؤولية سياسات الخصوصية الخاصة بتلك الجهات.</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        التعديلات على السياسة
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>يحق للمنصة تعديل سياسة الخصوصية في أي وقت.</p>
                        <p>ويعد استمرار استخدام التطبيق بعد التعديل موافقة ضمنية على السياسة المحدثة.</p>
                      </div>
                    </div>

                    {/* الموافقة النهائية */}
                    <div className="bg-gray-50 border-gray-300 rounded-lg p-6 mt-8">
                      <h3 className="text-xl font-bold text-[#58654C] mb-6">
                        الموافقة النهائية
                      </h3>

                      <div className="bg-gradient-to-r from-[#58654c5c] to-[#bfa25d5c] rounded-lg p-6 text-black">
                        <h4 className="font-bold mb-3 flex items-center text-sm">
                          <span className="text-2xl ml-3">✓</span>
                          إقرار الموافقة
                        </h4>
                        <p className="leading-relaxed text-sm">
                          <strong>
                            أقر بأنني قرأت سياسة الخصوصية وأوافق على جمع واستخدام ومعالجة بياناتي وفق ما ورد فيها، وبما يتوافق مع نظام حماية البيانات الشخصية في المملكة العربية السعودية.
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Contact Section */}
              <section className="bg-[#58654C] rounded-2xl shadow-lg p-8 text-center mt-16">
                <h2 className="text-2xl font-bold text-white mb-6">
                  استفسارات حول الخصوصية؟
                </h2>
                <p className="text-white/90 mb-8 leading-relaxed text-sm">
                  في حال وجود أي استفسار أو طلب متعلق بالخصوصية أو البيانات الشخصية، يمكن التواصل معنا
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <a
                    href="mailto:info@adim-app.com"
                    className="bg-white text-[#58654C] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200"
                  >
                    info@adim-app.com
                  </a>
                  <a
                    href="tel:+966557076035"
                    className="bg-[#BFA15D] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#BFA15D]/80 transition-colors duration-200"
                  >
                    0557076035
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#3E4736] text-white py-12 lg:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-start md:items-center justify-between gap-8">
            {/* Logo & Description */}
            <div className="flex flex-col justify-center items-start md:items-center ">
              <div className="flex flex-col justify-center items-start md:items-center gap-4 mb-4">
                <img
                  src={logo}
                  alt="أديم"
                  className="h-10 lg:h-12 brightness-0 invert"
                />
                <div className="flex flex-col justify-center items-center ">
                  <div className="text-white text-md lg:text-md font-bold">
                    منصتك الأولى لحجز خدمات المناسبات
                  </div>
                </div>
              </div>

              <p className="text-white max-w-md text-sm lg:text-sm leading-relaxed md:text-center">
                نجعل كل مناسبة تجربة استثنائية من خلال توفير أفضل الخدمات
                والمقدمين المعتمدين في المملكة العربية السعودية.
              </p>
            </div>

            {/* Links & Contact */}
            <div className="flex flex-col sm:flex-row gap-10 lg:gap-[10em] text-center">
              {/* Quick Links */}
              <div className="flex flex-col items-start justify-center">
                <h4 className="font-bold text-md mb-4 text-white">
                  روابط سريعة
                </h4>
                <ul className="space-y-2 text-gray-400 flex flex-col items-start justify-center">
                  <li>
                    <Link
                      to="/"
                      className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200"
                    >
                      الرئيسية
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/terms"
                      className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200"
                    >
                      شروط وأحكام الاستخدام
                    </Link>
                  </li>
                  <li>
                    <span
                      className="text-[#BFA15D] text-sm transition-colors duration-200 cursor-default"
                    >
                      سياسة الخصوصية
                    </span>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col items-start justify-center">
                <h4 className="font-bold text-md mb-4 text-white">
                  تواصل معنا
                </h4>
                <ul className="space-y-2 text-gray-400 flex flex-col items-start justify-center">
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    info@adim-app.com
                  </li>
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    <a href="tel:+966557076035">0557076035</a>
                  </li>
                 
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    الرياض - المملكة العربية السعودية
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t-[.005em] border-white mt-[5em] pt-8 text-center">
            <p className="text-white text-sm lg:sm font-bold">
              © 2026 أديم المناسبات. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
